"use strict";

module.exports = function () {
  return this.hasChildRow ? this.allColumns.length + 1 : this.allColumns.length;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tables-2/compiled/computed/colspan.js
// module id = 1628
// module chunks = 142